import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="w-full bg-[#1a2332] py-8 px-4" data-id="element-68">
        <div className="max-w-6xl mx-auto text-center" data-id="element-69">
          <div className="text-xl font-bold text-[#fbbf24] mb-2" data-id="element-70">
            Solo-Survival.com
          </div>
          <p className="text-gray-400 text-sm mb-4" data-id="element-71">
            © 2024 Solo-Survival. Todos los derechos reservados.
          </p>
          <div className="flex items-center justify-center gap-4 text-sm" data-id="element-72">
            <button onClick={() => setActiveModal('privacy')} className="text-gray-400 hover:text-[#fbbf24] transition-colors underline underline-offset-2" data-id="element-73">
              Política de Privacidad
            </button>
            <span className="text-gray-600" data-id="element-74">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-gray-400 hover:text-[#fbbf24] transition-colors underline underline-offset-2" data-id="element-75">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4" onClick={() => setActiveModal(null)} data-id="element-76">
          <div className="bg-white rounded-lg shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-77">
            <div className="sticky top-0 bg-white border-b border-gray-200 flex items-center justify-between p-6 rounded-t-lg" data-id="element-78">
              <h2 className="text-2xl font-bold text-[#1a2332]" data-id="element-79">
                {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h2>
              <button onClick={() => setActiveModal(null)} className="p-2 rounded-full hover:bg-gray-100 transition-colors" aria-label="Cerrar" data-id="element-80">
                <XIcon className="w-5 h-5 text-gray-600" data-id="element-81" />
              </button>
            </div>

            <div className="p-6 text-gray-700 leading-relaxed space-y-4" data-id="element-82">
              {activeModal === 'privacy' ? <>
                  <p className="text-sm text-gray-500" data-id="element-83">
                    Última actualización: Enero 2024
                  </p>

                  <h3 className="text-lg font-semibold text-[#1a2332]" data-id="element-84">
                    1. Información que recopilamos
                  </h3>
                  <p data-id="element-85">
                    Recopilamos únicamente la información necesaria para
                    procesar tu compra: nombre, dirección de correo electrónico
                    y datos de pago. No almacenamos información de tarjetas de
                    crédito en nuestros servidores.
                  </p>

                  <h3 className="text-lg font-semibold text-[#1a2332]" data-id="element-86">
                    2. Uso de la información
                  </h3>
                  <p data-id="element-87">
                    Tu información personal se utiliza exclusivamente para
                    entregar el producto digital adquirido y enviarte
                    comunicaciones relacionadas con tu compra. No compartimos,
                    vendemos ni cedemos tus datos a terceros con fines
                    comerciales.
                  </p>

                  <h3 className="text-lg font-semibold text-[#1a2332]" data-id="element-88">
                    3. Protección de datos
                  </h3>
                  <p data-id="element-89">
                    Utilizamos cifrado SSL para proteger toda la información
                    transmitida durante el proceso de compra. Implementamos
                    medidas de seguridad estándar de la industria para
                    resguardar tus datos personales.
                  </p>

                  <h3 className="text-lg font-semibold text-[#1a2332]" data-id="element-90">
                    4. Cookies
                  </h3>
                  <p data-id="element-91">
                    Nuestro sitio puede utilizar cookies para mejorar tu
                    experiencia de navegación y analizar el tráfico del sitio.
                    Puedes configurar tu navegador para rechazar cookies si lo
                    prefieres.
                  </p>

                  <h3 className="text-lg font-semibold text-[#1a2332]" data-id="element-92">
                    5. Tus derechos
                  </h3>
                  <p data-id="element-93">
                    Tienes derecho a acceder, rectificar o eliminar tus datos
                    personales en cualquier momento. Para ejercer estos
                    derechos, puedes comunicarte con nosotros a través de los
                    canales disponibles en nuestro sitio.
                  </p>
                </> : <>
                  <p className="text-sm text-gray-500" data-id="element-94">
                    Última actualización: Enero 2024
                  </p>

                  <h3 className="text-lg font-semibold text-[#1a2332]" data-id="element-95">
                    1. Producto digital
                  </h3>
                  <p data-id="element-96">
                    Solo-Survival: El Protocolo Despensa 1.0 es un producto
                    digital que incluye guías en formato PDF y plantillas en
                    formato Excel. Al completar tu compra, recibirás acceso
                    instantáneo a todos los materiales incluidos.
                  </p>

                  <h3 className="text-lg font-semibold text-[#1a2332]" data-id="element-97">
                    2. Licencia de uso
                  </h3>
                  <p data-id="element-98">
                    Al adquirir el producto, obtienes una licencia personal e
                    intransferible. Queda prohibida la reproducción,
                    distribución o reventa del material sin autorización
                    expresa.
                  </p>

                  <h3 className="text-lg font-semibold text-[#1a2332]" data-id="element-99">
                    3. Política de reembolso
                  </h3>
                  <p data-id="element-100">
                    Debido a la naturaleza digital del producto y su entrega
                    inmediata, no se aceptan devoluciones una vez realizada la
                    descarga. Si experimentas problemas técnicos con los
                    archivos, nos comprometemos a resolverlos.
                  </p>

                  <h3 className="text-lg font-semibold text-[#1a2332]" data-id="element-101">
                    4. Resultados
                  </h3>
                  <p data-id="element-102">
                    Los resultados de ahorro mencionados son promedios basados
                    en reportes de usuarios y pueden variar según los hábitos de
                    consumo, ubicación geográfica y nivel de implementación del
                    sistema por parte de cada usuario.
                  </p>

                  <h3 className="text-lg font-semibold text-[#1a2332]" data-id="element-103">
                    5. Modificaciones
                  </h3>
                  <p data-id="element-104">
                    Nos reservamos el derecho de modificar estos términos en
                    cualquier momento. Las modificaciones entrarán en vigor
                    desde su publicación en el sitio web.
                  </p>
                </>}
            </div>

            <div className="border-t border-gray-200 p-6" data-id="element-105">
              <button onClick={() => setActiveModal(null)} className="w-full py-3 bg-[#1a2332] text-white font-semibold rounded-lg hover:bg-[#243447] transition-colors" data-id="element-106">
                Cerrar
              </button>
            </div>
          </div>
        </div>}
    </>;
}